import { useState } from "react";
import { toast } from "sonner";
import { apiErr } from "@/lib/api";
import { waLinkWithText } from "@/lib/whatsapp";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { Mail, Copy } from "lucide-react";

// Email · WhatsApp · Copy link. `send(channel)` must resolve to { url, whatsapp_text, client_phone, emailed_to, email_error }.
export function SendLinkButtons({ send, testid, onDone, compact = false }) {
  const [busy, setBusy] = useState("");
  const run = async (channel) => {
    const win = channel === "whatsapp" ? window.open("", "_blank") : null; // open now so the browser doesn't block it
    setBusy(channel);
    try {
      const r = await send(channel);
      if (channel === "email") {
        if (r.emailed_to) toast.success(`Emailed to ${r.emailed_to}`);
        else toast.warning(`Not emailed: ${r.email_error || "unknown error"}. Use WhatsApp or Copy link instead.`);
      } else if (channel === "whatsapp") {
        const link = waLinkWithText(r.client_phone, r.whatsapp_text);
        if (link && win) win.location.href = link;
        else { win?.close(); await navigator.clipboard?.writeText(r.url); toast.warning("No valid phone number on file — link copied instead"); }
      } else {
        await navigator.clipboard?.writeText(r.url);
        toast.success("Link copied");
      }
      onDone?.(r);
    } catch (e) { win?.close(); toast.error(apiErr(e)); } finally { setBusy(""); }
  };
  const cls = `inline-flex items-center gap-1.5 ${compact ? "px-2.5 py-1.5 text-xs" : "px-3 py-2 text-sm"} rounded-xl font-semibold disabled:opacity-60`;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      <button data-testid={`${testid}-email`} disabled={!!busy} onClick={() => run("email")} className={`${cls} bg-primary text-white`}><Mail className="h-4 w-4" /> {busy === "email" ? "Sending…" : "Email"}</button>
      <button data-testid={`${testid}-whatsapp`} disabled={!!busy} onClick={() => run("whatsapp")} className={`${cls} bg-[#25D366] text-white`}><WhatsAppIcon className="h-4 w-4" /> WhatsApp</button>
      <button data-testid={`${testid}-copy`} disabled={!!busy} onClick={() => run("link")} className={`${cls} border border-slate-200 text-slate-700 bg-white`}><Copy className="h-4 w-4" /> Copy link</button>
    </div>
  );
}
